(function () {
  'use strict';

  var root = document.querySelector('[data-enquiry-root]');
  if (!root) return;

  var endpoint = root.getAttribute('data-worker-endpoint').replace(/\/?$/, '');
  var accentColor = root.getAttribute('data-accent-color');
  if (accentColor) {
    root.style.setProperty('--hs-teal', accentColor);
  }
  var successHeadingTemplate = root.getAttribute('data-success-heading-template') || 'Thanks, {name}!';
  var autoCloseSeconds = parseInt(root.getAttribute('data-auto-close-seconds'), 10) || 0;
  var responseTimeText = root.getAttribute('data-response-time-text') || 'within 24 hours';

  var overlay = root.querySelector('[data-enquiry-overlay]');
  var closeBtn = root.querySelector('[data-enquiry-close]');
  var formView = root.querySelector('[data-enquiry-form-view]');
  var successView = root.querySelector('[data-enquiry-success]');
  var successTitle = root.querySelector('[data-enquiry-success-title]');
  var successMsg = root.querySelector('[data-enquiry-success-msg]');
  var successContact = root.querySelector('[data-enquiry-success-contact]');
  var successRef = root.querySelector('[data-enquiry-success-ref]');
  var form = root.querySelector('[data-enquiry-form]');
  var errorEl = root.querySelector('[data-enquiry-error]');
  var submitBtn = root.querySelector('[data-enquiry-submit]');

  var productSearchWrap = root.querySelector('[data-enquiry-product-search]');
  var productInput = root.querySelector('[data-enquiry-product-input]');
  var productDrop = root.querySelector('[data-enquiry-product-drop]');
  var productPicked = root.querySelector('[data-enquiry-product-picked]');
  var productPickedImg = root.querySelector('[data-enquiry-product-img]');
  var productPickedTitle = root.querySelector('[data-enquiry-product-title]');
  var productClearBtn = root.querySelector('[data-enquiry-product-clear]');

  var phoneCombo = root.querySelector('[data-enquiry-phone-combo]');
  var phoneTrigger = root.querySelector('[data-enquiry-phone-trigger]');
  var phoneTriggerFlag = root.querySelector('[data-enquiry-phone-flag]');
  var phoneTriggerCode = root.querySelector('[data-enquiry-phone-code]');
  var phoneDropdown = root.querySelector('[data-enquiry-phone-dropdown]');
  var phoneSearchInput = root.querySelector('[data-enquiry-phone-search]');
  var phoneList = root.querySelector('[data-enquiry-phone-list]');
  var phoneLocalInput = root.querySelector('#hs-enq-phone');

  var selectedProduct = null;
  var autoCloseTimer = null;
  var detectedDialCode = '1'; // fallback: US
  var currentCountryCode = 'US';

  // ---------- ISO2 → international dial code ----------
  var DIAL_CODES = {
    AF:"93",AL:"355",DZ:"213",AD:"376",AO:"244",AG:"1",AR:"54",AM:"374",AU:"61",AT:"43",
    AZ:"994",BS:"1",BH:"973",BD:"880",BB:"1",BY:"375",BE:"32",BZ:"501",BJ:"229",BT:"975",
    BO:"591",BA:"387",BW:"267",BR:"55",BN:"673",BG:"359",BF:"226",BI:"257",CV:"238",KH:"855",
    CM:"237",CA:"1",CF:"236",TD:"235",CL:"56",CN:"86",CO:"57",KM:"269",CG:"242",CR:"506",
    HR:"385",CU:"53",CY:"357",CZ:"420",DK:"45",DJ:"253",DM:"1",DO:"1",EC:"593",EG:"20",
    SV:"503",GQ:"240",ER:"291",EE:"372",SZ:"268",ET:"251",FJ:"679",FI:"358",FR:"33",GA:"241",
    GM:"220",GE:"995",DE:"49",GH:"233",GR:"30",GD:"1",GT:"502",GN:"224",GW:"245",GY:"592",
    HT:"509",HN:"504",HU:"36",IS:"354",IN:"91",ID:"62",IR:"98",IQ:"964",IE:"353",IL:"972",
    IT:"39",CI:"225",JM:"1",JP:"81",JO:"962",KZ:"7",KE:"254",KI:"686",XK:"383",KW:"965",
    KG:"996",LA:"856",LV:"371",LB:"961",LS:"266",LR:"231",LY:"218",LI:"423",LT:"370",LU:"352",
    MG:"261",MW:"265",MY:"60",MV:"960",ML:"223",MT:"356",MH:"692",MR:"222",MU:"230",MX:"52",
    FM:"691",MD:"373",MC:"377",MN:"976",ME:"382",MA:"212",MZ:"258",MM:"95",NA:"264",NR:"674",
    NP:"977",NL:"31",NZ:"64",NI:"505",NE:"227",NG:"234",KP:"850",MK:"389",NO:"47",OM:"968",
    PK:"92",PW:"680",PS:"970",PA:"507",PG:"675",PY:"595",PE:"51",PH:"63",PL:"48",PT:"351",
    QA:"974",RO:"40",RU:"7",RW:"250",KN:"1",LC:"1",VC:"1",WS:"685",SM:"378",ST:"239",
    SA:"966",SN:"221",RS:"381",SC:"248",SL:"232",SG:"65",SK:"421",SI:"386",SB:"677",SO:"252",
    ZA:"27",KR:"82",SS:"211",ES:"34",LK:"94",SD:"249",SR:"597",SE:"46",CH:"41",SY:"963",
    TW:"886",TJ:"992",TZ:"255",TH:"66",TL:"670",TG:"228",TO:"676",TT:"1",TN:"216",TR:"90",
    TM:"993",TV:"688",UG:"256",UA:"380",AE:"971",GB:"44",US:"1",UY:"598",UZ:"998",VU:"678",
    VA:"379",VE:"58",VN:"84",YE:"967",ZM:"260",ZW:"263"
  };

  // ---------- ISO2 → country name (same 196-country list) ----------
  var COUNTRY_NAMES = {
    AF:"Afghanistan",AL:"Albania",DZ:"Algeria",AD:"Andorra",AO:"Angola",AG:"Antigua and Barbuda",AR:"Argentina",AM:"Armenia",AU:"Australia",AT:"Austria",
    AZ:"Azerbaijan",BS:"Bahamas",BH:"Bahrain",BD:"Bangladesh",BB:"Barbados",BY:"Belarus",BE:"Belgium",BZ:"Belize",BJ:"Benin",BT:"Bhutan",
    BO:"Bolivia",BA:"Bosnia and Herzegovina",BW:"Botswana",BR:"Brazil",BN:"Brunei",BG:"Bulgaria",BF:"Burkina Faso",BI:"Burundi",CV:"Cabo Verde",KH:"Cambodia",
    CM:"Cameroon",CA:"Canada",CF:"Central African Republic",TD:"Chad",CL:"Chile",CN:"China",CO:"Colombia",KM:"Comoros",CG:"Congo (Congo-Brazzaville)",CR:"Costa Rica",
    HR:"Croatia",CU:"Cuba",CY:"Cyprus",CZ:"Czechia",DK:"Denmark",DJ:"Djibouti",DM:"Dominica",DO:"Dominican Republic",EC:"Ecuador",EG:"Egypt",
    SV:"El Salvador",GQ:"Equatorial Guinea",ER:"Eritrea",EE:"Estonia",SZ:"Eswatini",ET:"Ethiopia",FJ:"Fiji",FI:"Finland",FR:"France",GA:"Gabon",
    GM:"Gambia",GE:"Georgia",DE:"Germany",GH:"Ghana",GR:"Greece",GD:"Grenada",GT:"Guatemala",GN:"Guinea",GW:"Guinea-Bissau",GY:"Guyana",
    HT:"Haiti",HN:"Honduras",HU:"Hungary",IS:"Iceland",IN:"India",ID:"Indonesia",IR:"Iran",IQ:"Iraq",IE:"Ireland",IL:"Israel",
    IT:"Italy",CI:"Ivory Coast",JM:"Jamaica",JP:"Japan",JO:"Jordan",KZ:"Kazakhstan",KE:"Kenya",KI:"Kiribati",XK:"Kosovo",KW:"Kuwait",
    KG:"Kyrgyzstan",LA:"Laos",LV:"Latvia",LB:"Lebanon",LS:"Lesotho",LR:"Liberia",LY:"Libya",LI:"Liechtenstein",LT:"Lithuania",LU:"Luxembourg",
    MG:"Madagascar",MW:"Malawi",MY:"Malaysia",MV:"Maldives",ML:"Mali",MT:"Malta",MH:"Marshall Islands",MR:"Mauritania",MU:"Mauritius",MX:"Mexico",
    FM:"Micronesia",MD:"Moldova",MC:"Monaco",MN:"Mongolia",ME:"Montenegro",MA:"Morocco",MZ:"Mozambique",MM:"Myanmar",NA:"Namibia",NR:"Nauru",
    NP:"Nepal",NL:"Netherlands",NZ:"New Zealand",NI:"Nicaragua",NE:"Niger",NG:"Nigeria",KP:"North Korea",MK:"North Macedonia",NO:"Norway",OM:"Oman",
    PK:"Pakistan",PW:"Palau",PS:"Palestine",PA:"Panama",PG:"Papua New Guinea",PY:"Paraguay",PE:"Peru",PH:"Philippines",PL:"Poland",PT:"Portugal",
    QA:"Qatar",RO:"Romania",RU:"Russia",RW:"Rwanda",KN:"Saint Kitts and Nevis",LC:"Saint Lucia",VC:"Saint Vincent and the Grenadines",WS:"Samoa",SM:"San Marino",ST:"Sao Tome and Principe",
    SA:"Saudi Arabia",SN:"Senegal",RS:"Serbia",SC:"Seychelles",SL:"Sierra Leone",SG:"Singapore",SK:"Slovakia",SI:"Slovenia",SB:"Solomon Islands",SO:"Somalia",
    ZA:"South Africa",KR:"South Korea",SS:"South Sudan",ES:"Spain",LK:"Sri Lanka",SD:"Sudan",SR:"Suriname",SE:"Sweden",CH:"Switzerland",SY:"Syria",
    TW:"Taiwan",TJ:"Tajikistan",TZ:"Tanzania",TH:"Thailand",TL:"Timor-Leste",TG:"Togo",TO:"Tonga",TT:"Trinidad and Tobago",TN:"Tunisia",TR:"Turkey",
    TM:"Turkmenistan",TV:"Tuvalu",UG:"Uganda",UA:"Ukraine",AE:"United Arab Emirates",GB:"United Kingdom",US:"United States",UY:"Uruguay",UZ:"Uzbekistan",VU:"Vanuatu",
    VA:"Vatican City",VE:"Venezuela",VN:"Vietnam",YE:"Yemen",ZM:"Zambia",ZW:"Zimbabwe"
  };

  // dial codes shared by multiple countries — pick a sensible default
  var PRIMARY_FOR_DIAL = { "1": "US", "7": "RU" };

  function findCountryByDial(digitsOnly) {
    var maxLen = Math.min(4, digitsOnly.length);
    for (var len = maxLen; len >= 1; len--) {
      var candidate = digitsOnly.slice(0, len);
      if (PRIMARY_FOR_DIAL[candidate]) return { code: PRIMARY_FOR_DIAL[candidate], dial: candidate };
      for (var code in DIAL_CODES) {
        if (DIAL_CODES[code] === candidate) return { code: code, dial: candidate };
      }
    }
    return null;
  }

  // ---------- Phone country combo (custom dropdown with real flag icons) ----------
  function applyDialCode(countryCode) {
    var cc = (countryCode || 'US').toUpperCase();
    if (!DIAL_CODES[cc]) cc = 'US';
    currentCountryCode = cc;
    detectedDialCode = DIAL_CODES[cc];
    if (phoneTriggerFlag) {
      phoneTriggerFlag.className = 'fi fi-' + cc.toLowerCase() + ' hs-phone-trigger-flag';
    }
    if (phoneTriggerCode) phoneTriggerCode.textContent = '+' + detectedDialCode;
    if (phoneList) {
      phoneList.querySelectorAll('.hs-phone-dropdown-item').forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-code') === cc);
      });
    }
  }

  function buildPhoneList(filterText) {
    if (!phoneList) return;
    var q = (filterText || '').trim().toLowerCase();
    var codes = Object.keys(DIAL_CODES).sort(function (a, b) {
      return (COUNTRY_NAMES[a] || a).localeCompare(COUNTRY_NAMES[b] || b);
    });
    phoneList.innerHTML = '';
    var shown = 0;
    codes.forEach(function (code) {
      var name = COUNTRY_NAMES[code] || code;
      var dial = DIAL_CODES[code];
      if (q && name.toLowerCase().indexOf(q) === -1 && code.toLowerCase().indexOf(q) === -1 && dial.indexOf(q.replace('+', '')) === -1) return;
      shown++;
      var item = document.createElement('div');
      item.className = 'hs-phone-dropdown-item' + (code === currentCountryCode ? ' is-active' : '');
      item.setAttribute('role', 'option');
      item.setAttribute('data-code', code);
      item.innerHTML =
        '<span class="fi fi-' + code.toLowerCase() + '"></span>' +
        '<span class="hs-phone-dropdown-name"></span>' +
        '<span class="hs-phone-dropdown-dial">+' + dial + '</span>';
      item.querySelector('.hs-phone-dropdown-name').textContent = name;
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        applyDialCode(code);
        closePhoneDropdown();
        if (phoneLocalInput) phoneLocalInput.focus();
      });
      phoneList.appendChild(item);
    });
    if (!shown) {
      phoneList.innerHTML = '<div class="hs-phone-dropdown-empty">No country found</div>';
    }
  }

  function openPhoneDropdown() {
    if (!phoneDropdown) return;
    buildPhoneList('');
    phoneDropdown.hidden = false;
    phoneTrigger.setAttribute('aria-expanded', 'true');
    if (phoneSearchInput) { phoneSearchInput.value = ''; setTimeout(function () { phoneSearchInput.focus(); }, 30); }
  }
  function closePhoneDropdown() {
    if (!phoneDropdown) return;
    phoneDropdown.hidden = true;
    phoneTrigger.setAttribute('aria-expanded', 'false');
  }
  if (phoneTrigger) {
    phoneTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (phoneDropdown.hidden) openPhoneDropdown(); else closePhoneDropdown();
    });
  }
  if (phoneSearchInput) {
    phoneSearchInput.addEventListener('input', function () { buildPhoneList(phoneSearchInput.value); });
  }
  document.addEventListener('click', function (e) {
    if (phoneCombo && !phoneCombo.contains(e.target)) closePhoneDropdown();
  });

  applyDialCode('US'); // default while geo-detecting
  fetch(endpoint + '/geo')
    .then(function (r) { return r.json(); })
    .then(function (d) { applyDialCode(d && d.country); })
    .catch(function () { /* keep default */ });

  // ---------- Typing "+91 ..." or "0091 ..." directly auto-switches the country, and strips junk ----------
  if (phoneLocalInput) {
    phoneLocalInput.addEventListener('input', function () {
      if (phoneLocalInput._syncing) return;
      var val = phoneLocalInput.value;

      var prefixMatch = val.match(/^\s*(?:\+|00)(\d{1,4})/);
      if (prefixMatch) {
        var match = findCountryByDial(prefixMatch[1]);
        if (match) {
          applyDialCode(match.code);
          // strip exactly match.dial.length digits — not a greedy 4-digit guess
          var stripRe = new RegExp('^\\s*(?:\\+|00)\\d{' + match.dial.length + '}[\\s-]*');
          val = val.replace(stripRe, '');
        }
      }

      var cleaned = val.replace(/\D/g, '').slice(0, 12);
      phoneLocalInput._syncing = true;
      phoneLocalInput.value = cleaned;
      phoneLocalInput._syncing = false;
    });
  }

  // ---------- Reusable trigger — any element anywhere with this class opens the popup ----------
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.hs-enquiry-trigger');
    if (!trigger) return;
    e.preventDefault();
    openPopup();
  });

  function openPopup() {
    clearTimeout(autoCloseTimer);
    overlay.hidden = false;
    formView.hidden = false;
    successView.hidden = true;
    var firstInput = form.querySelector('#hs-enq-name');
    if (firstInput) setTimeout(function () { firstInput.focus(); }, 50);
    document.addEventListener('keydown', onKeydown);
  }
  function closePopup() {
    overlay.hidden = true;
    clearTimeout(autoCloseTimer);
    document.removeEventListener('keydown', onKeydown);
  }
  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    if (phoneDropdown && !phoneDropdown.hidden) { closePhoneDropdown(); return; }
    closePopup();
  }
  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });

  // ---------- Auto-select product if this popup is opened on a product page ----------
  var currentProductTitle = root.getAttribute('data-current-product-title');
  if (currentProductTitle) {
    selectProduct({
      title: currentProductTitle,
      url: root.getAttribute('data-current-product-url'),
      image: root.getAttribute('data-current-product-image'),
      handle: root.getAttribute('data-current-product-handle')
    });
  }

  function selectProduct(p) {
    selectedProduct = p;
    productPickedTitle.textContent = p.title;
    productPickedImg.src = p.image || '';
    productPicked.hidden = false;
    productSearchWrap.hidden = true;
    productInput.value = '';
    productDrop.hidden = true;
  }

  function clearProduct() {
    selectedProduct = null;
    productPicked.hidden = true;
    productSearchWrap.hidden = false;
    productInput.focus();
  }
  productClearBtn.addEventListener('click', clearProduct);

  // ---------- Live product search — fast, cancels stale requests, tolerant of typos ----------
  var searchDebounce = null;
  var productAbortController = null;

  function levenshtein(a, b) {
    var m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    var prev = [], curr = [];
    for (var j = 0; j <= n; j++) prev[j] = j;
    for (var i = 1; i <= m; i++) {
      curr[0] = i;
      for (var k = 1; k <= n; k++) {
        var cost = a[i - 1] === b[k - 1] ? 0 : 1;
        curr[k] = Math.min(prev[k] + 1, curr[k - 1] + 1, prev[k - 1] + cost);
      }
      prev = curr.slice();
    }
    return prev[n];
  }

  function fuzzyScore(query, title) {
    var qTokens = query.toLowerCase().split(/\s+/).filter(Boolean);
    var tTokens = title.toLowerCase().split(/\s+/).filter(Boolean);
    var score = 0;
    qTokens.forEach(function (qt) {
      var best = 0;
      tTokens.forEach(function (tt) {
        if (tt.indexOf(qt) !== -1 || qt.indexOf(tt) !== -1) { best = Math.max(best, 2); return; }
        var tolerance = qt.length <= 4 ? 1 : 2;
        if (levenshtein(qt, tt) <= tolerance) best = Math.max(best, 1);
      });
      score += best;
    });
    return score;
  }

  function buildSearchQuery(q) {
    var tokens = q.split(/\s+/).filter(Boolean);
    if (!tokens.length) return q;
    tokens[tokens.length - 1] = tokens[tokens.length - 1] + '*'; // prefix-match the word being typed
    return tokens.join(' ');
  }

  function renderProductResults(results) {
    if (!results.length) {
      productDrop.innerHTML = '<div class="hs-enquiry__product-empty">No products found</div>';
      productDrop.hidden = false;
      return;
    }
    productDrop.innerHTML = '';
    results.forEach(function (p) {
      var item = document.createElement('div');
      item.className = 'hs-enquiry__product-item';
      var img = (p.featured_image && p.featured_image.url) ? (p.featured_image.url + '&width=80') : (p.image || '');
      item.innerHTML = (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '<span></span>';
      item.querySelector('span').textContent = p.title;
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        selectProduct({
          title: p.title,
          url: window.location.origin + (p.url || ('/products/' + (p.handle || ''))),
          image: img,
          handle: p.handle || null
        });
      });
      productDrop.appendChild(item);
    });
    productDrop.hidden = false;
  }

  function runProductSearch(q) {
    if (productAbortController) productAbortController.abort();
    var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    productAbortController = controller;

    fetch('/search/suggest.json?q=' + encodeURIComponent(buildSearchQuery(q)) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last', {
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var results = (d.resources && d.resources.results && d.resources.results.products) || [];
        results = results
          .map(function (p) { return { p: p, score: fuzzyScore(q, p.title) }; })
          .filter(function (x) { return x.score > 0; })
          .sort(function (a, b) { return b.score - a.score; })
          .map(function (x) { return x.p; });
        renderProductResults(results);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return; // a newer keystroke superseded this request
        productDrop.hidden = true;
      });
  }

  productInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') e.preventDefault(); // don't submit the form from the search box
  });
  productInput.addEventListener('input', function () {
    var q = productInput.value.trim();
    clearTimeout(searchDebounce);
    if (!q) { productDrop.hidden = true; if (productAbortController) productAbortController.abort(); return; }
    productDrop.innerHTML = '<div class="hs-enquiry__product-loading">Searching…</div>';
    productDrop.hidden = false;
    searchDebounce = setTimeout(function () { runProductSearch(q); }, 150);
  });
  productInput.addEventListener('blur', function () {
    setTimeout(function () { productDrop.hidden = true; }, 200);
  });

  // ---------- Inline "touched" state for nicer validation styling ----------
  form.querySelectorAll('input[required]').forEach(function (inp) {
    inp.addEventListener('blur', function () { inp.setAttribute('data-touched', 'true'); });
  });

  // ---------- Analytics context ----------
  // Real source saved earlier by the "hs_touch" snippet in theme.liquid (used only when this visit has no source of its own).
  function readStoredTouch() {
    try {
      var t = JSON.parse(window.localStorage.getItem('hs_touch') || 'null');
      if (!t || !t.ts || (Date.now() - t.ts) > 30 * 86400000) return null;
      var sp = new URLSearchParams();
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { if (t[k]) sp.set(k, t[k]); });
      if (t.gclid) sp.set('gclid', '1');
      if (t.fbclid) sp.set('fbclid', '1');
      return { params: sp, referrer: t.referrer || '' };
    } catch (e) { return null; }
  }
  function detectTrafficSource() {
    var params = new URLSearchParams(window.location.search);
    var ref = document.referrer;
    var refIsOwn = false;
    try { refIsOwn = !!ref && new URL(ref).hostname.replace(/^www\./, '') === window.location.hostname.replace(/^www\./, ''); } catch (e) { /* ignore */ }
    if (!params.get('utm_source') && !params.get('gclid') && !params.get('fbclid') && (!ref || refIsOwn)) {
      var stored = readStoredTouch();
      if (stored) { params = stored.params; ref = stored.referrer; }
    }
    var utmSource = params.get('utm_source');
    var utmMedium = params.get('utm_medium');
    var utmCampaign = params.get('utm_campaign');
    if (params.get('gclid')) return { source: 'google_ads', medium: 'paid', campaign: utmCampaign };
    if (params.get('fbclid')) return { source: 'facebook_ads', medium: 'paid', campaign: utmCampaign };
    if (utmSource) return { source: utmSource, medium: utmMedium || 'unknown', campaign: utmCampaign };
    if (!ref) return { source: 'direct', medium: 'none', campaign: null };
    try {
      var refHost = new URL(ref).hostname.replace(/^www\./, '');
      var thisHost = window.location.hostname.replace(/^www\./, '');
      if (refHost === thisHost) return { source: 'internal', medium: 'site', campaign: null };
      if (/google\./.test(refHost)) return { source: 'google', medium: 'organic', campaign: null };
      if (/bing\./.test(refHost)) return { source: 'bing', medium: 'organic', campaign: null };
      if (/facebook\.|instagram\./.test(refHost)) return { source: refHost, medium: 'social', campaign: null };
      return { source: refHost, medium: 'referral', campaign: null };
    } catch (e) { return { source: 'unknown', medium: 'unknown', campaign: null }; }
  }
  function detectDeviceType() {
    var ua = navigator.userAgent || '';
    if (/tablet|ipad/i.test(ua)) return 'tablet';
    if (/mobile|android|iphone/i.test(ua)) return 'mobile';
    return 'desktop';
  }
  var analyticsContext = {
    trafficSource: detectTrafficSource(),
    deviceType: detectDeviceType(),
    landingPage: window.location.href,
    referrer: document.referrer || null,
    language: navigator.language || null,
    browserTimezone: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch (e) { return null; } })(),
    visitorId: (function () { try { var m = document.cookie.match(/(?:^|; )hs_vid=([^;]+)/); return m ? decodeURIComponent(m[1]).slice(0, 64) : null; } catch (e) { return null; } })()
  };

  // ---------- Optional audiogram / report upload ----------
  var uploadWrap = root.querySelector('[data-enq-upload]');
  var uploadInput = root.querySelector('[data-enq-file]');
  var uploadDrop = root.querySelector('[data-enq-drop]');
  var uploadList = root.querySelector('[data-enq-files]');
  var uploadErr = root.querySelector('[data-enq-upload-err]');
  var uploadItems = [];                 // { name, size, status: 'uploading'|'done'|'error', id, msg }
  var MAX_REPORT_FILES = 3;
  var MAX_REPORT_BYTES = 5 * 1024 * 1024;
  var REPORT_EXT = /\.(pdf|jpe?g|png|webp|heic|heif)$/i;

  function showUploadErr(msg) {
    if (!uploadErr) return;
    uploadErr.textContent = msg || '';
    uploadErr.hidden = !msg;
  }
  function uploadsBusy() {
    return uploadItems.some(function (it) { return it.status === 'uploading'; });
  }
  function renderUploads() {
    if (!uploadList) return;
    uploadList.innerHTML = '';
    uploadItems.forEach(function (it, i) {
      var li = document.createElement('li');
      li.className = 'hs-enquiry__file is-' + it.status;
      var n = document.createElement('span');
      n.className = 'hs-enquiry__file-name';
      n.textContent = it.name;
      var st = document.createElement('span');
      st.className = 'hs-enquiry__file-status';
      st.textContent = it.status === 'uploading' ? 'Uploading…' : (it.status === 'done' ? 'Attached' : (it.msg || 'Failed'));
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'hs-enquiry__file-remove';
      rm.setAttribute('aria-label', 'Remove file');
      rm.innerHTML = '&times;';
      rm.addEventListener('click', function () {
        uploadItems.splice(uploadItems.indexOf(it), 1);
        showUploadErr('');
        renderUploads();
      });
      li.appendChild(n); li.appendChild(st); li.appendChild(rm);
      uploadList.appendChild(li);
    });
    if (uploadDrop) uploadDrop.setAttribute('aria-disabled', uploadItems.length >= MAX_REPORT_FILES ? 'true' : 'false');
  }
  function uploadOne(item, file) {
    var fd = new FormData();
    fd.append('file', file);
    fetch(endpoint + '/upload', { method: 'POST', body: fd })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (d) { return { ok: res.ok, status: res.status, d: d }; });
      })
      .then(function (r) {
        if (r.ok && r.d && r.d.id) {
          item.status = 'done'; item.id = r.d.id; item.name = r.d.name || item.name; item.size = r.d.size || item.size; item.type = r.d.type || '';
        } else {
          item.status = 'error';
          item.msg = r.status === 503 ? 'Uploads unavailable' : 'Failed';
          showUploadErr((r.d && r.d.message) || 'Could not upload that file. You can still send the enquiry.');
        }
      })
      .catch(function () {
        item.status = 'error'; item.msg = 'Failed';
        showUploadErr('Could not upload that file. Check your connection and try again.');
      })
      .then(renderUploads);
  }
  if (uploadInput) {
    uploadInput.addEventListener('change', function () {
      showUploadErr('');
      var files = Array.prototype.slice.call(uploadInput.files || []);
      uploadInput.value = '';
      files.forEach(function (file) {
        if (uploadItems.length >= MAX_REPORT_FILES) { showUploadErr('You can attach up to ' + MAX_REPORT_FILES + ' files.'); return; }
        if (!REPORT_EXT.test(file.name || '')) { showUploadErr('Please upload a PDF, JPG, PNG, WEBP or HEIC file.'); return; }
        if (file.size > MAX_REPORT_BYTES) { showUploadErr('"' + file.name + '" is larger than 5 MB.'); return; }
        var item = { name: file.name, size: file.size, status: 'uploading', id: null };
        uploadItems.push(item);
        uploadOne(item, file);
      });
      renderUploads();
    });
  }
  function clearUploads() {
    uploadItems = [];
    showUploadErr('');
    renderUploads();
  }

  // ---------- Submit ----------
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.hidden = true;

    if (!form.checkValidity()) {
      form.querySelectorAll('input[required]').forEach(function (inp) { inp.setAttribute('data-touched', 'true'); });
      form.reportValidity();
      return;
    }

    if (uploadsBusy()) {
      errorEl.textContent = 'Please wait — your report is still uploading.';
      errorEl.hidden = false;
      return;
    }

    var fd = new FormData(form);
    var nameVal = fd.get('name');
    var localPhone = (phoneLocalInput ? phoneLocalInput.value.trim() : fd.get('phone_local'));
    var payload = {
      name: nameVal,
      email: fd.get('email'),
      phone: '+' + detectedDialCode + ' ' + localPhone,
      preferred_contact: fd.get('preferred_contact'),
      message: fd.get('message') || null,
      product_title: selectedProduct ? selectedProduct.title : null,
      product_url: selectedProduct ? selectedProduct.url : null,
      product_image: selectedProduct ? selectedProduct.image : null,
      product_handle: selectedProduct ? selectedProduct.handle : null,
      response_time_text: root.getAttribute('data-response-time-text'),
      support_phone: root.getAttribute('data-support-phone'),
      page_url: window.location.href,
      report_files: uploadItems.filter(function (it) { return it.status === 'done' && it.id; }).map(function (it) {
        return { id: it.id, name: it.name, size: it.size, type: it.type || '' };
      }),
      context: analyticsContext
    };

    submitBtn.disabled = true;
    var originalLabel = submitBtn.textContent;
    submitBtn.textContent = 'Sending...';

    fetch(endpoint + '/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.error || 'Request failed'); });
        return res.json();
      })
      .then(function (data) {
        showSuccess(nameVal, selectedProduct, payload.preferred_contact, data.id);
      })
      .catch(function (err) {
        errorEl.textContent = 'Something went wrong — please try again.';
        errorEl.hidden = false;
        console.error('HearSilk quick enquiry error:', err);
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
      });
  });

  function showSuccess(name, product, preferredContact, submissionId) {
    var firstName = (name || '').trim().split(' ')[0] || 'there';
    if (successTitle) {
      successTitle.textContent = successHeadingTemplate.replace('{name}', firstName);
    }
    if (successMsg) {
      var productPhrase = product ? (' about ' + product.title) : '';
      var base = successMsg.getAttribute('data-template') || successMsg.textContent;
      successMsg.setAttribute('data-template', base);
      successMsg.textContent = base.replace('{product}', productPhrase);
    }
    if (successContact) {
      successContact.textContent = preferredContact
        ? "We'll reach out via " + preferredContact + ' ' + responseTimeText + '.'
        : "We'll be in touch " + responseTimeText + '.';
    }
    if (successRef && submissionId) {
      successRef.textContent = 'Reference: ' + submissionId;
    }

    formView.hidden = true;
    successView.hidden = false;
    form.reset();
    clearUploads();
    if (currentProductTitle) {
      // keep the auto-detected product selected for next time this popup opens
    } else {
      clearProduct();
    }

    if (autoCloseSeconds > 0) {
      autoCloseTimer = setTimeout(closePopup, autoCloseSeconds * 1000);
    }
  }
})();